import { Injectable } from '@angular/core';

import { Observable, Subject } from 'rxjs';

import { MwCoreToolbarOptions } from './core-toolbar.options';

@Injectable({
  providedIn: 'root',
})
export class MwCoreToolbarService {
  get backClick$(): Observable<any> {
    return this.localBackClick$.asObservable();
  }

  get options$(): Observable<MwCoreToolbarOptions> {
    return this.localOptions$.asObservable();
  }

  private localBackClick$ = new Subject<void>();
  private localOptions$ = new Subject<MwCoreToolbarOptions>();

  setOptions(options: MwCoreToolbarOptions): void {
    this.localOptions$.next(options);
  }

  emitBackClickEvent(): void {
    this.localBackClick$.next();
  }
}
